import script from "./MarketingLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketingLayout.vue?vue&type=script&setup=true&lang=js"

import "./MarketingLayout.vue?vue&type=style&index=0&id=e3d12f9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3d12f9c"]])

export default __exports__